/**
 * Het vaste document-ID van de outputregistratie die bij één roosterregel op
 * één dag hoort.
 *
 * Doordat het ID vastligt, kunnen de nachtklus en een handmatige registratie
 * vanuit de agenda niet naast elkaar bestaan: wie het eerst is legt vast, de
 * ander ziet dat het er al staat. Zonder dit zou dezelfde dag twee keer geteld
 * worden.
 *
 * SPIEGEL: functions/personas/scheduleOutputDocId.js — wijzig ze samen, anders
 * schrijven de agenda en de nachtklus weer naar verschillende documenten.
 *
 * @param {string} scheduleID - Document-ID van de roosterregel (Task)
 * @param {string} dateKey - De dag als YYYY-MM-DD
 * @returns {string} Het document-ID, of '' als er iets ontbreekt
 */
const scheduleOutputDocId = (scheduleID, dateKey) => {
    if (!scheduleID || !dateKey) return ''
    return `event_output_${scheduleID}_${dateKey}`
}

export default scheduleOutputDocId
